// YSC & SUD Template Titles
const YSCEnglishTemplateTitle = 'YSC English Template'
const YSCFrenchTemplateTitle = 'YSC French Template'
const SUDCommunityEnTemplateTitle = 'SUD Community Projects EN'
const SUDCommunityFrTemplateTitle = 'SUD Community Projects FR'
const SUDRainbowEnTemplateTitle = 'SUD Rainbow Board EN'
const SUDRainbowFrTemplateTitle = 'SUD Rainbow Board FR'
const SUDCSCNEnTemplateTitle = 'SUD CSCN EN'
const SUDCSCNFrTemplateTitle = 'SUD CSCN FR'
const SUDCatholicEnTemplateTitle = 'SUD Catholic Schools EN'
const SUDCatholicFrTemplateTitle = 'SUD Catholic Schools FR'

const YSC2022FinalistTemplateTitle = 'YSC Finalist Template'

// YSC & SUD Template IDs
const YSC2024EnglishTemplate = 136775
const YSC2024FrenchTemplate = 136777
const SUD2024CommunityEnTemplate = 141075
const SUD2024CommunityFrTemplate = 141079
const SUD2024RainbowEnTemplate = 141076
const SUD2024RainbowFrTemplate = 141080
const SUD2024CSCNEnTemplate = 141077
const SUD2024CSCNFrTemplate = 141081
const SUD2024CatholicEnTemplate = 141078
const SUD2024CatholicFrTemplate = 141082

const YSC2023EnglishTemplate = 110540
const YSC2023FrenchTemplate = 110542
const SUD2023CommunityEnTemplate = 104617
const SUD2023CommunityFrTemplate = 104618
const SUD2023RainbowEnTemplate = 104979
const SUD2023RainbowFrTemplate = 104983
const SUD2023CSCNEnTemplate = 104984
const SUD2023CSCNFrTemplate = 104985
const SUD2023CatholicEnTemplate = 104986
const SUD2023CatholicFrTemplate = 104987

const YSC2022EnglishTemplate = 72044
const YSC2022FrenchTemplate = 72045
const YSC2022FinalistTemplate = 89587
const SUD2022CommunityEnTemplate = 69598
const SUD2022CommunityFrTemplate = 69599
const SUD2022RainbowEnTemplate = 69600
const SUD2022RainbowFrTemplate = 69603
const SUD2022CSCNEnTemplate = 69604
const SUD2022CSCNFrTemplate = 69605
const SUD2022CatholicEnTemplate = 69606
const SUD2022CatholicFrTemplate = 69607

const YSC2021EnglishTemplate = 42088
const YSC2021FrenchTemplate = 42087
const SUD2021CommunityEnTemplate = 41325
const SUD2021CommunityFrTemplate = 41389
const SUD2021RainbowEnTemplate = 41695
const SUD2021RainbowFrTemplate = 41692
const SUD2021CSCNEnTemplate = 41696
const SUD2021CSCNFrTemplate = 41693
const SUD2021CatholicEnTemplate = 41697
const SUD2021CatholicFrTemplate = 41694

// ISEF Template IDs
const ISEF2023Template = 108467

// OAS Template IDs
const ScienceDayTemplate = 92391
const BIOTemplate = 67469

const DSD2023Template = 130995
const BuckeyeE2023Template = 130996
const OhioStepTemplate = 130997

const OasamTemplate = 134389

const OAS2023FairTemplates = [DSD2023Template, BuckeyeE2023Template, OhioStepTemplate]
const ProjectTemplates = [ScienceDayTemplate, BIOTemplate]

export default {
  data: function () {
    return {
      ScienceDayTemplate,
      BIOTemplate,
      ProjectTemplates,
      YSC2023EnglishTemplate,
      YSC2023FrenchTemplate,
      ISEF2023Template,
      DSD2023Template,
      BuckeyeE2023Template,
      OhioStepTemplate,
      OAS2023FairTemplates,
      OasamTemplate,
      YSC2024EnglishTemplate,
      YSC2024FrenchTemplate,
      SUD2024CommunityEnTemplate,
      SUD2024CommunityFrTemplate,
      SUD2024RainbowEnTemplate,
      SUD2024RainbowFrTemplate,
      SUD2024CSCNEnTemplate,
      SUD2024CSCNFrTemplate,
      SUD2024CatholicEnTemplate,
      SUD2024CatholicFrTemplate,
      YSCEnglishTemplateTitle,
      YSCFrenchTemplateTitle,
      SUDCommunityEnTemplateTitle,
      SUDCommunityFrTemplateTitle,
      SUDRainbowEnTemplateTitle,
      SUDRainbowFrTemplateTitle,
      SUDCSCNEnTemplateTitle,
      SUDCSCNFrTemplateTitle,
      SUDCatholicEnTemplateTitle,
      SUDCatholicFrTemplateTitle,
      SUD2023CommunityEnTemplate,
      SUD2023CommunityFrTemplate,
      SUD2023RainbowEnTemplate,
      SUD2023RainbowFrTemplate,
      SUD2023CSCNEnTemplate,
      SUD2023CSCNFrTemplate,
      SUD2023CatholicEnTemplate,
      SUD2023CatholicFrTemplate,
      YSC2022EnglishTemplate,
      YSC2022FrenchTemplate,
      YSC2022FinalistTemplate,
      YSC2022FinalistTemplateTitle,
      SUD2022CommunityEnTemplate,
      SUD2022CommunityFrTemplate,
      SUD2022RainbowEnTemplate,
      SUD2022RainbowFrTemplate,
      SUD2022CSCNEnTemplate,
      SUD2022CSCNFrTemplate,
      SUD2022CatholicEnTemplate,
      SUD2022CatholicFrTemplate,
      YSC2021EnglishTemplate,
      YSC2021FrenchTemplate,
      SUD2021CommunityEnTemplate,
      SUD2021CommunityFrTemplate,
      SUD2021RainbowEnTemplate,
      SUD2021RainbowFrTemplate,
      SUD2021CSCNEnTemplate,
      SUD2021CSCNFrTemplate,
      SUD2021CatholicEnTemplate,
      SUD2021CatholicFrTemplate
    }
  }
}
